// extracted by mini-css-extract-plugin
export var dateLabel = "_3o-0";
export var dateLabelError = "_3o-1";
export var fullWidth = "_3o-2";
export var smaller = "_3o-3";